import React from 'react';
import * as Types from 'pages/General/typings';
import makeStyles from '@material-ui/core/styles/makeStyles';
import { Fields } from 'types/FormValue';

import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import CardContent from '@material-ui/core/CardContent';
import Divider from '@material-ui/core/Divider';

import CompanyName from './CompanyName';
import AllowUninvited from './AllowUninvited';
import Subdomain from './Subdomain';
import CompanyTimezone from './CompanyTimezone';
import OrgLevelsLayout from './OrgLevelsLayout';
import LogoUploader from './LogoUploader';
import Terminology from './Terminology';
import CustomNavigationTab from './CustomNavigationTab';
import Support from './Support';
import DottedLineRelationships from './DottedLineRelationships';

interface Props {
  values: Types.GeneralValues;
  errors: Types.GeneralFormErrors;
  userStatus: number;
  fields: Fields;
  onChange: (field: string, value: any) => void;
}

function Settings({ values, errors, userStatus, fields, onChange }: Props) {
  const classes = useStyles();

  return (
    <>
      <Card>
        <CardHeader title={<div className={classes.h5}>Basic Information</div>} />
        <Divider />
        <CardContent>
          <>
            <CompanyName
              value={values.client.displayName}
              error={errors.displayName}
              onChange={onChange}
            />
            {!values.client.isTrial && (
              <Subdomain
                value={values.client.subdomain.toLowerCase()}
                error={errors.subdomain}
                onChange={onChange}
              />
            )}
            <CompanyTimezone value={values.client.settings.info.timeZone} onChange={onChange} />
          </>
          <LogoUploader setFieldValue={onChange} logoUrl={values.client.settings.info.logoUrl} />
        </CardContent>
      </Card>
      <OrgLevelsLayout
        onChange={onChange}
        userStatus={userStatus}
        fields={Object.values(fields)}
        values={values}
      />
      <DottedLineRelationships values={values} onChange={onChange} />
      <AllowUninvited
        value={!values.client.settings.login.blockCreatedAccounts.enabled}
        onChange={onChange}
      />
      <Terminology
        errorMessage={errors}
        subtitle="Change what words are used to refer to team members and team leaders throughout Sift."
        title="Person Terminology"
        teamMemberUpdateKey="client.settings.terminology.teamMember"
        teamLeaderUpdateKey="client.settings.terminology.teamLeader"
        value={values.client.settings.terminology}
        onChange={onChange}
        renderTeamLeaderField
      />
      <CustomNavigationTab onChange={onChange} values={values} />

      <Support
        onChange={onChange}
        value={values.client.settings.support}
        errorMessage={errors.support}
      />
    </>
  );
}

const useStyles = makeStyles(theme => ({
  root: {},
  h5: {
    ...theme.typography.h5,
  },
}));

export default Settings;
